/**
 * OAuth provider config registry.
 *
 * Separated from the `<OAuthProviders />` component so utility lookups
 * (display name, icon, support check) can be imported without pulling in the
 * UI component (which would defeat React Fast Refresh).
 */

import React from 'react';
import { GithubIcon } from 'lucide-react';
import { GoogleIcon, GitLabIcon, BitbucketIcon } from './oauthIcons';

export type OAuthProvider =
  | 'github'
  | 'gitlab'
  | 'bitbucket'
  | 'google'
  | 'microsoft'
  | 'apple'
  | 'slack';

export interface ProviderConfig {
  id: OAuthProvider;
  name: string;
  icon: React.ComponentType<{ className?: string }>;
  color: string;
  hoverColor: string;
  textColor: string;
}

export interface ProviderConfigExtended extends ProviderConfig {
  comingSoon?: boolean;
}

export const providerConfigs: ProviderConfigExtended[] = [
  {
    id: 'google',
    name: 'Google',
    icon: GoogleIcon,
    color: 'rgba(66, 133, 244, 0.1)',
    hoverColor: 'rgba(66, 133, 244, 0.15)',
    textColor: '#4285F4',
  },
  {
    id: 'github',
    name: 'GitHub',
    icon: GithubIcon,
    color: 'rgba(36, 41, 47, 0.1)',
    hoverColor: 'rgba(36, 41, 47, 0.15)',
    textColor: 'var(--color-text-primary)',
  },
  {
    id: 'gitlab',
    name: 'GitLab',
    icon: GitLabIcon,
    color: 'rgba(226, 67, 41, 0.1)',
    hoverColor: 'rgba(226, 67, 41, 0.15)',
    textColor: '#E24329',
  },
  {
    id: 'bitbucket',
    name: 'Bitbucket',
    icon: BitbucketIcon,
    color: 'rgba(38, 132, 255, 0.1)',
    hoverColor: 'rgba(38, 132, 255, 0.15)',
    textColor: '#2684FF',
  },
];
